export default __webpack_public_path__ + "static/3-74d0a352530336656ce7fb9bf3f8d469.png";